import type { Cart } from "./types";
import { EMPTY_CART } from "./types";
import { canonicalizeCart } from "./canonicalize";

export const CART_KEY = "mag-portal-cart";
// PASTE #363: fingerprint of the last cart we synced to the server for the
// signed-in user. On boot we compare it to the current local cart to tell a
// SYNCED copy (reload / cross-device / impersonation leftover -> load the server
// cart, never re-merge) from genuine unsynced GUEST additions (-> adopt once).
export const CART_SYNC_KEY = "mag-portal-cart-synced";

export function readCart(): Cart {
  try {
    const raw = window.localStorage.getItem(CART_KEY);
    if (!raw) return EMPTY_CART;
    const parsed = JSON.parse(raw) as Cart;
    if (!parsed || !Array.isArray(parsed.boxes)) return EMPTY_CART;
    return parsed;
  } catch {
    return EMPTY_CART;
  }
}

export function writeCart(cart: Cart): void {
  try {
    // PASTE #384: canonicalize to the SERVER / invoice packing on EVERY write,
    // so the live drawer + /cart render the exact pack the server + invoice use
    // (no reload, no round-trip). canonicalizeCart is a no-op (returns the cart
    // untouched) when the variety cache can't cover every slug, so a line can
    // never be dropped.
    const canonical = canonicalizeCart(cart);
    window.localStorage.setItem(CART_KEY, JSON.stringify(canonical));
    window.dispatchEvent(new CustomEvent("mag-portal-cart-changed"));
  } catch {
    // ignore
  }
}

export function clearCart(): void {
  try {
    window.localStorage.removeItem(CART_KEY);
    window.localStorage.removeItem(CART_SYNC_KEY);
    window.dispatchEvent(new CustomEvent("mag-portal-cart-changed"));
  } catch {
    // ignore
  }
}

// PASTE #363: the sync marker - the item fingerprint we last pushed to / loaded
// from the server for the signed-in user.
export function readCartSyncMarker(): string | null {
  try {
    return window.localStorage.getItem(CART_SYNC_KEY);
  } catch {
    return null;
  }
}

export function writeCartSyncMarker(hash: string): void {
  try {
    window.localStorage.setItem(CART_SYNC_KEY, hash);
  } catch {
    // ignore
  }
}
